module.exports = __webpack_public_path__ + "traumaTwo-04f14cfb98e3bb42d2d90cfdae444658.png";